<html>
<body>
    <script>
        parent.postMessage(location.href, location.origin)
    </script>
</body>
</html>